var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_26506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 2.96774C7.56131 2.96774 7.22583 2.63226 7.22583 2.19355V0.774194C7.22583 0.335484 7.56131 0 8.00002 0C8.43873 0 8.77422 0.335484 8.77422 0.774194V2.19355C8.77422 2.60645 8.43873 2.96774 8.00002 2.96774Z",
    fill: "currentFill",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 16C7.56131 16 7.22583 15.6645 7.22583 15.2258V13.8065C7.22583 13.3678 7.56131 13.0323 8.00002 13.0323C8.43873 13.0323 8.77422 13.3678 8.77422 13.8065V15.2258C8.77422 15.6645 8.43873 16 8.00002 16Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08395 3.74194C4.82588 3.74194 4.56782 3.61291 4.41298 3.35485L3.7162 2.14194C3.50975 1.78065 3.63879 1.29033 4.00008 1.08388C4.36137 0.877429 4.85169 1.00646 5.05814 1.36775L5.75491 2.58065C5.96137 2.94194 5.83233 3.43227 5.47104 3.63872C5.36782 3.69033 5.21298 3.74194 5.08395 3.74194Z",
    fill: "#10a37e29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.613 15.0193C11.3549 15.0193 11.0969 14.8903 10.942 14.6323L10.2453 13.4193C10.0388 13.0581 10.1678 12.5677 10.5291 12.3613C10.8904 12.1548 11.3807 12.2839 11.5872 12.6452L12.284 13.8581C12.4904 14.2193 12.3614 14.7097 12.0001 14.9161C11.8711 14.9935 11.742 15.0193 11.613 15.0193Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96775 5.85808C2.83872 5.85808 2.70969 5.83227 2.58065 5.75485L1.36775 5.05808C1.00646 4.85163 0.877429 4.3613 1.08388 4.00001C1.29033 3.63872 1.78065 3.50969 2.14194 3.71614L3.35485 4.41292C3.71614 4.61937 3.84517 5.10969 3.63872 5.47098C3.48388 5.72905 3.22582 5.85808 2.96775 5.85808Z",
    fill: "#10a37e29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2709 12.3871C14.1419 12.3871 14.0128 12.3613 13.8838 12.2838L12.6451 11.5871C12.2838 11.3806 12.1548 10.8903 12.3612 10.529C12.5677 10.1677 13.058 10.0387 13.4193 10.2451L14.6322 10.9419C14.9935 11.1484 15.1225 11.6387 14.9161 12C14.787 12.258 14.529 12.3871 14.2709 12.3871Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19355 8.77422H0.774194C0.335484 8.77422 0 8.43873 0 8.00002C0 7.56131 0.335484 7.22583 0.774194 7.22583H2.19355C2.63226 7.22583 2.96774 7.56131 2.96774 8.00002C2.96774 8.43873 2.60645 8.77422 2.19355 8.77422Z",
    fill: "#10a37e29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2258 8.77422H13.8064C13.3677 8.77422 13.0322 8.43873 13.0322 8.00002C13.0322 7.56131 13.3677 7.22583 13.8064 7.22583H15.2258C15.6645 7.22583 16 7.56131 16 8.00002C16 8.43873 15.6645 8.77422 15.2258 8.77422Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72897 12.3871C1.4709 12.3871 1.21284 12.258 1.058 12C0.85155 11.6387 0.980582 11.1484 1.34187 10.9419L2.55478 10.2451C2.91607 10.0387 3.40639 10.1677 3.61284 10.529C3.81929 10.8903 3.69026 11.3806 3.32897 11.5871L2.11607 12.2838C2.01284 12.3613 1.88381 12.3871 1.72897 12.3871Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0322 5.85808C12.7741 5.85808 12.5161 5.72905 12.3612 5.47098C12.1548 5.10969 12.2838 4.61937 12.6451 4.41292L13.858 3.71614C14.2193 3.50969 14.7096 3.63872 14.9161 4.00001C15.1225 4.3613 14.9935 4.85163 14.6322 5.05808L13.4193 5.75485C13.2903 5.83227 13.1612 5.85808 13.0322 5.85808Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38717 15.0193C4.25814 15.0193 4.12911 14.9935 4.00008 14.9161C3.63879 14.7097 3.50975 14.2193 3.7162 13.8581L4.41298 12.6452C4.61943 12.2839 5.10975 12.1548 5.47104 12.3613C5.83233 12.5677 5.96137 13.0581 5.75491 13.4193L5.05814 14.6323C4.9033 14.8903 4.64524 15.0193 4.38717 15.0193Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9162 3.74194C10.7872 3.74194 10.6582 3.71614 10.5291 3.63872C10.1678 3.43227 10.0388 2.94194 10.2453 2.58065L10.942 1.36775C11.1485 1.00646 11.6388 0.877429 12.0001 1.08388C12.3614 1.29033 12.4904 1.78065 12.284 2.14194L11.5872 3.35485C11.4324 3.58711 11.1743 3.74194 10.9162 3.74194Z",
    fill: "#10a37e29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_26506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/StatusIcon.86ff7847571606861feab6fbd337cc35.svg";
export { ForwardRef as ReactComponent };